import { useAppSelector } from "../../../hooks/app";
import TournamentTeamBaseComponent from "./components/tournamentTeam/TournamentTeamBaseComponent";
import { TournamentTypeEnum } from "../../../commons/enums/tournament-type-enum";
import TournamentTeamGroupedComponent from "./components/tournamentTeam/TournamentTeamGroupedComponent";

export default function TournamentManageTeams() {
  const { fetchedCompetition } = useAppSelector((state) => state.fetchedCompetition);

  return (
    <>
      {fetchedCompetition.type === TournamentTypeEnum.Hybrid ? (
        <TournamentTeamGroupedComponent />
      ) : (
        <TournamentTeamBaseComponent />
      )}
    </>
  );
}
